import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { map, Observable } from 'rxjs';

import { IPaperProjectData } from 'editing-tool/src/app/shared/components/paper/steps/project/paper-project/paper-project-data.model';
import { IPaperProjectListData } from 'editing-tool/src/app/shared/components/paper/steps/project/paper-project-list-data';
import { ApiAuthorProject } from 'sc-common/core/services/open-api/main-api-client';

@Component({
    selector: 'et-paper-project-list',
    templateUrl: './paper-project-list.component.html',
    styleUrls: ['./paper-project-list.component.scss'],
    standalone: false
})
export class PaperProjectListComponent implements OnInit {

    @Input()
    public data: IPaperProjectListData;

    @Input()
    public isReadonly: boolean;

    @Output()
    public readonly titleSelected = new EventEmitter<{ titleId: number; titleName: string; }>();

    public projectsData$: Observable<IPaperProjectData[]>;

    public selectedProject$: Observable<IPaperProjectData>;

    constructor(private readonly _sanitizer: DomSanitizer) {
    }

    public ngOnInit(): void {

        this.projectsData$ = this.data.authorProjects$.pipe(map(projects => projects.map(project => this._mapProjectToData(project))));
        this.selectedProject$ = this.data.selectedProject$.pipe(map(project => this._mapProjectToData(project)));
    }

    private _mapProjectToData(project: ApiAuthorProject): IPaperProjectData {
        return {
            project: project,
            coverSource$: this.data.getCover(project.titleId)
                .pipe(map(i => this._sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(i.data)))),
            onSelectProjectAction: (titleId: number, titleName: string) => this.titleSelected.emit({ titleId, titleName })
        };
    }
}
